import useService from 'main/hooks/useService'
import { getSession } from '@/services/companiesServices'
import { getResaleSiteFromUrl } from '@/utils/functionUtils'
import { useEffect } from 'react'

export const Movidesk = () => {
  //todo apos refatoração do login modificar funcionamento
  const [getSessionState, getSessionRequest] = useService(getSession, {
    onCompleted: (res) => {
      const key = res.data.resale.chatBotKey
      const script = document.createElement('script')
      script.innerHTML = `var mdChatClient="${key}";`
      script.type = 'text/javascript'
      script.id = 'movideskScript'
      document.body.appendChild(script)

      const moviDeskScript = document.createElement('script')
      moviDeskScript.src = 'https://chat.movidesk.com/Scripts/chat-widget.min.js'
      document.body.appendChild(moviDeskScript)
    },
  })

  useEffect(() => {
    if (getSessionState.response?.data?.resale) return
    const movideskScriptElement = document.getElementById('movideskScript')
    if (!movideskScriptElement) {
      getSessionRequest(getResaleSiteFromUrl())
    }
    // eslint-disable-next-line
  }, [])
}
